module.exports = __webpack_public_path__ + "static/media/3.c7a90625.jpg";